import { Flex, Th, Tr } from '@chakra-ui/react'
import { SortDirection, SortField } from '../utils/sortUtils'
import SortIcon from './SortIcon'

interface TableHeaderProps {
  sortField: SortField
  sortDirection: SortDirection
  sortingField: SortField
  onSort: (field: SortField) => void
  emailFirst?: boolean
}

const TableHeader = ({
  sortField,
  sortDirection,
  sortingField,
  onSort,
  emailFirst = false,
}: TableHeaderProps) => {
  return (
    <Tr>
      {emailFirst && <Th>Email</Th>}
      {emailFirst && <Th>Name</Th>}
      {!emailFirst && (
        <Th onClick={() => onSort('name')} cursor='pointer'>
          <Flex align='center'>
            Name
            <SortIcon
              active={sortField === 'name'}
              direction={sortDirection}
              isSorting={sortingField === 'name'}
              field='name'
            />
          </Flex>
        </Th>
      )}
      <Th>ID</Th>
      <Th onClick={() => onSort('studies')} cursor='pointer'>
        <Flex align='center'>
          Studies
          <SortIcon
            active={sortField === 'studies'}
            direction={sortDirection}
            isSorting={sortingField === 'studies'}
            field='studies'
          />
        </Flex>
      </Th>
      <Th onClick={() => onSort('reports')} cursor='pointer'>
        <Flex align='center'>
          Reports
          <SortIcon
            active={sortField === 'reports'}
            direction={sortDirection}
            isSorting={sortingField === 'reports'}
            field='reports'
          />
        </Flex>
      </Th>
      <Th onClick={() => onSort('diagnosis')} cursor='pointer'>
        <Flex align='center'>
          Diagnosis
          <SortIcon
            active={sortField === 'diagnosis'}
            direction={sortDirection}
            isSorting={sortingField === 'diagnosis'}
            field='diagnosis'
          />
        </Flex>
      </Th>
      <Th onClick={() => onSort('diagnosisDate')} cursor='pointer'>
        <Flex align='center'>
          Diagnosis Date
          <SortIcon
            active={sortField === 'diagnosisDate'}
            direction={sortDirection}
            isSorting={sortingField === 'diagnosisDate'}
            field='diagnosisDate'
          />
        </Flex>
      </Th>
      <Th onClick={() => onSort('role')} cursor='pointer'>
        <Flex align='center'>
          Role
          <SortIcon
            active={sortField === 'role'}
            direction={sortDirection}
            isSorting={sortingField === 'role'}
            field='role'
          />
        </Flex>
      </Th>
      <Th>Phone</Th>
      {!emailFirst && <Th>Email</Th>}
      <Th onClick={() => onSort('country')} cursor='pointer'>
        <Flex align='center'>
          Country
          <SortIcon
            active={sortField === 'country'}
            direction={sortDirection}
            isSorting={sortingField === 'country'}
            field='country'
          />
        </Flex>
      </Th>
      <Th onClick={() => onSort('state')} cursor='pointer'>
        <Flex align='center'>
          State/Province
          <SortIcon
            active={sortField === 'state'}
            direction={sortDirection}
            isSorting={sortingField === 'state'}
            field='state'
          />
        </Flex>
      </Th>
      <Th onClick={() => onSort('city')} cursor='pointer'>
        <Flex align='center'>
          City
          <SortIcon
            active={sortField === 'city'}
            direction={sortDirection}
            isSorting={sortingField === 'city'}
            field='city'
          />
        </Flex>
      </Th>
    </Tr>
  )
}

export default TableHeader
